import React from "react";
import DialogModal from "../../../../components/DialogModal";
import { ProjectInterface } from "../../../../interfaces";

interface ViewProjectContentModalProps {
  open: boolean;
  projectData: ProjectInterface | null;
  onDismissed: () => void;
}

const ViewProjectContentModal: React.FC<ViewProjectContentModalProps> = (props) => {
  const html = props.projectData ? props.projectData.content.replace(/<img/g, '<img width="100%"').replace(/<br>/g, "") : "";

  return (
    <DialogModal
      maxWidth="lg"
      title="Project Content"
      component={
        <div style={{ width: "100%", maxWidth: "100%" }}>
          <img alt={props.projectData?.title} src={props.projectData?.cover_img} style={{ width: "100%", height: "auto" }} />
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      }
      contentType="custom"
      open={props.open}
      onDismissed={props.onDismissed}
    />
  );
};

export default ViewProjectContentModal;
